module.exports = __webpack_public_path__ + "img/615-42dfb3.png";